// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v5.0.1-rc.2-9-g6c590560",
    "hash": "g6c590560",
    "distance": 9,
    "tag": "v5.0.1-rc.2",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v5.0.1-rc.2",
        "major": 5,
        "minor": 0,
        "patch": 1,
        "prerelease": [
            "rc",
            2
        ],
        "build": [],
        "version": "5.0.1-rc.2"
    },
    "suffix": "9-g6c590560",
    "semverString": "5.0.1-rc.2+9.g6c590560",
    "version": "5.0.1"
};
/* tslint:enable */
